import {Component, Inject, Input, ViewEncapsulation} from "@angular/core";
import { DOCUMENT } from '@angular/platform-browser'
require('./section-category.component.scss');

@Component({
  templateUrl: './section-category.component.html',
  styleUrls: [ './section-category.component.scss' ],
  selector: 'sectionCategory',
  encapsulation: ViewEncapsulation.None
})
export class SectionCategoryComponent {

  @Input() articles: Array<any> = [];
  @Input() insuranceCostGuide;
  @Input() homeImprovementCostGuide;

  constructor(@Inject(DOCUMENT) protected  document: any,){

  }
}



// WEBPACK FOOTER //
// ./src/app/category/section/section-category.component.ts